// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .MuiGrid-root.gradient-background.height-content {
  height: 80vh;
  overflow-y: auto;
} */

.MuiGrid-root.cartoon-model {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 20px;
  justify-content: center;
  margin-top: 20px;
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .MuiGrid-root.cartoon-model {
    flex-direction: row;
    gap: 0px;
  }
}

@media screen and (min-width: 1024px) {
  .MuiGrid-root.cartoon-model {
    flex-direction: row;
    justify-content: flex-start;
    gap: 0px;
    align-items: center;
  }
}

@media screen and (min-width: 1600px) {
  .MuiGrid-root.cartoon-model {
    flex-direction: row;
  }
}

.stacked-images {
  object-fit: contain;
  width: 100%;
  border-radius: 10px;
  /* height: 300px; */
}

.MuiCardContent-root.card-content {
  background: linear-gradient(to bottom, rgba(72, 49, 157, 0.2) 20%, rgba(72, 49, 157, 0) 100%);
}

`, "",{"version":3,"sources":["webpack://./src/components/Cartoon/Cartoon.css"],"names":[],"mappings":"AAAA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6FAA6F;AAC/F","sourcesContent":["/* .MuiGrid-root.gradient-background.height-content {\n  height: 80vh;\n  overflow-y: auto;\n} */\n\n.MuiGrid-root.cartoon-model {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-direction: column;\n  flex-wrap: wrap;\n  padding: 20px;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .MuiGrid-root.cartoon-model {\n    flex-direction: row;\n    gap: 0px;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .MuiGrid-root.cartoon-model {\n    flex-direction: row;\n    justify-content: flex-start;\n    gap: 0px;\n    align-items: center;\n  }\n}\n\n@media screen and (min-width: 1600px) {\n  .MuiGrid-root.cartoon-model {\n    flex-direction: row;\n  }\n}\n\n.stacked-images {\n  object-fit: contain;\n  width: 100%;\n  border-radius: 10px;\n  /* height: 300px; */\n}\n\n.MuiCardContent-root.card-content {\n  background: linear-gradient(to bottom, rgba(72, 49, 157, 0.2) 20%, rgba(72, 49, 157, 0) 100%);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
